<template>
  <div>
    <div v-for="(list, index) in renderedLists" :key="index" class="freelancer-list-container">
      <div class="freelancer-list-div">
        <div :class="'freelancer-list-div-div_'+list.type">
          <router-link
            class="nounderlinehover"
            @contextmenu.native="handleGlobalClick('Blog','Blog Modal', list.type === 'user' ? 'profile' : list.type, impressionUUID, list.type === 'gig' ? {gig_id:list.action.mobile.gig_id, seller_id:list.action.mobile.seller_id} : {})"
            @click.native="handleGlobalClick('Blog','Blog Modal', list.type === 'user' ? 'profile' : list.type, impressionUUID, list.type === 'gig' ? {gig_id:list.action.mobile.gig_id, seller_id:list.action.mobile.seller_id} : {})"
            :to="list.action.url">
            <img v-if="list.type === 'gig'" class="freelancer-list-avatar" :src="list.image_url"/>
            <img v-if="list.type === 'user'" class="freelancer-list-avatar_s" :src="list.image_url"/>
          </router-link>
        </div>
        <div class="freelancer-list-second-flex">
          <router-link class="nounderlinehover"
                       @contextmenu.native="handleGlobalClick('Blog','Blog Modal', list.type === 'user' ? 'profile' : list.type, impressionUUID, list.type === 'gig' ? {gig_id:list.action.mobile.gig_id, seller_id:list.action.mobile.seller_id} : {})"
                       @click.native="handleGlobalClick('Blog','Blog Modal', list.type === 'user' ? 'profile' : list.type, impressionUUID, list.type === 'gig' ? {gig_id:list.action.mobile.gig_id, seller_id:list.action.mobile.seller_id} : {})"
                       :to="list.action.url">
            <p v-if="list.type === 'user'" class="freelancer-list-username">{{list.title}}</p>
            <p v-if="list.type === 'gig'" class="freelancer-list-user-title" style="padding-top: 6px;">{{list.title}}</p>
            <p v-if="list.type === 'user'" class="freelancer-list-user-title_s">{{list.subtitle}}</p>
            <p v-if="list.type === 'gig'" style="font-size: 14px; font-weight: 500; color: #2d3640; padding-top: 4px;">{{list.subtitle}}</p>
          </router-link>
        </div>


      </div>
      <div v-if="index !== renderedLists.length - 1 && list.type === 'gig'" class="freelancer-list-border" ></div>
      <div v-if="index !== renderedLists.length - 1 && list.type === 'user'" class="freelancer-list-border_s" ></div>
    </div>

    <div class="line" style="margin-top: 10px; margin-bottom: 10px;"></div>
  </div>
</template>

<script>

  import Loader from "../toolbox/loader.vue";


  export default {
    components:{Loader},
    props: ["list","type", "slug", "impressionUUID"],
    data() {
      return {
        loader:true,

        renderedLists:[
          {
            action_url:'',
            image_url:'',
            title:'',
            subtitle:'',
            action:{
              action:'',
              subtext:'',
              text:'',
              url:''

            },
          }
        ]




      };
    },

    methods:{

      sendMessage(user) {
        this.EventBus.$emit('externalOpenChat', {r_username: user.title, r_avatar_url: user.image_url});
      }
    },

    created() {

      this.api.content.renderList(this.type, this.list)
        .then(({data}) => {
          let result = data;
          if (result.success) {

            let trackGigObj = [];
            let k = 1;
            result.data.list.forEach((rList)=> {
              if(rList.type === 'gig'){
                trackGigObj.push({
                  gig_id: rList.action.mobile.gig_id,
                  seller_id: rList.action.mobile.seller_id,
                  order_id: k
                })
                k++;
              }
            });
            if(trackGigObj.length > 0){
              let trackingProps = {
                page:'blogdetail',
                placement:'list',
                info:trackGigObj,
                term: this.slug,
                title: this.impressionUUID
              };
              this.Helper.trackEvents.customEvent("gig_impressions", trackingProps);
            }

            this.renderedLists = result.data.list;
            this.loader = false;
          } else {
            this.$toasted.global.errorToast({description: result.message});
            this.loader = false;
          }
        })
        .catch(err => {
          this.$toasted.global.errorToast({description: this.Constants.TEXTS.SERVER_ERROR_MESSAGE});
          this.loader = false;
        });

    }
  }
</script>

<style scoped lang="scss">


.nounderlinehover{
  text-decoration: none!important;
  display: block;
}


  .freelancer-list{
    margin-right: 14px
  }

  .freelancer-list-div{
    display: flex; height: 100px;
  }

  .freelancer-list-div-div_user{
    align-self: center;
    width: 232px;

  }

  .freelancer-list-div-div_gig{
    align-self: center;
    width: 232px;


  }

  .freelancer-list-avatar{
    height:45px;  border:1px solid #dde3eb;border-radius: 4px;
  }

  .freelancer-list-avatar_s{
    height:80px;  border:1px solid #dde3eb;border-radius: 12px;
  }


  .freelancer-list-second-flex{
    margin-left: 32px; height: 80px; align-self: center; width: 500px;
  }

  .freelancer-list-username{padding-top: 5px;
    line-height:36px;font-size: 24px; font-weight: 400; color: rgb(36, 36, 36);
  }

  .freelancer-list-user-title{
    text-decoration: none!important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.3;
    letter-spacing: normal;
    color: #2d3640;
    margin-right: 12px;
  }

  .freelancer-list-border{
    margin-left:177px;border-bottom: 1px solid #e1e1e1; margin-right: 32px;
  }

  .freelancer-list-border_s{
    margin-left:110px;border-bottom: 1px solid #e1e1e1; margin-right: 32px;
  }


  .freelancer-list-user-title_s{
    text-decoration: none!important;
    line-height:19px; font-size: 15px;  color: #5e6b79;
  }

</style>
